import React, { useEffect } from "react";
import { Body1Strong } from "@fluentui/react-components";
import { useStyles } from "../../shared/SharedStyles";
import { BuildingCafeList, appInsightsEvents, trackEvent, useAppStore } from "../../../common";
import { CafeCard } from "../CafeCard";

interface BuildingCardProps {
  building: BuildingCafeList;
}

export const BuildingCard = ({ building }: BuildingCardProps) => {
  const styles = useStyles();
  const context = useAppStore((state) => state.context);
  const appInsights = useAppStore((state) => state.appInsights);

  useEffect(() => {
    trackEvent(appInsights, appInsightsEvents.Usage.ViewComponent, context, {
      componentName: "BuildingCard",
      buildingId: building.id,
      buildingName: building.name,
      buildingCafeCount: building.cafeList.length,
    });
  }, [context, appInsights, building]);
  return (
    <div data-testid={building.id} key={building.id} className={styles.container}>
      {building.name && (
        <div className={styles.header}>
          <Body1Strong className={styles.smallHeaderText} data-testid="buildingName">
            {building.name}
          </Body1Strong>
        </div>
      )}
      <div className={styles.list}>
        {building.cafeList.map((cafe, i) => (
          <CafeCard key={i} cafe={cafe} />
        ))}
      </div>
    </div>
  );
};
